import { ListItemText } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";
import { STListItemIcon, STListItem, STListItemText } from "./styles";
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";
import { observer, inject } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import { computed } from "mobx";
import { ISearchStore } from "@src/Stores/Search/types";

interface IProps {
  text: string;
  to: string;
  icon: React.ComponentType<SvgIconProps>;
  routing?: RouterStore;
  search?: ISearchStore;
  onDrawerToggle: () => void;
}

@inject("routing", "search")
@observer
class MenuItem extends React.Component<IProps> {
  @computed get isActive() {
    if (this.props.search.globalSearchActive) {
      return false;
    }
    return this.props.routing.location.pathname === this.props.to;
  }
  handlePush = () => {
    this.props.search.setSearchString("");
    this.props.routing.history.push(this.props.to);
    this.props.onDrawerToggle();
  };

  render() {
    const Icon = this.props.icon;
    return (
      <STListItem button={false} selected={this.isActive} onClick={this.handlePush}>
        <STListItemIcon>
          <Icon />
        </STListItemIcon>
        <STListItemText primary={this.props.text} />
        <TouchRipple />
      </STListItem>
    );
  }
}

export default MenuItem;
